<template>
  <div v-if="editModel">
    <el-form
      ref="form"
      :size="$xUISize"
      :model="editModel"
      :rules="editRules"
      @submit.native.prevent
      label-width="auto"
      label-position="top"
    >
      <el-card v-loading="loading" shadow="hover">
        <div style="padding: 10px 20px">
          <el-form-item label="分销商名称" prop="distributorName">
            <el-input
              placeholder="请输入分销商名称"
              v-model="editModel.distributorName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="配送费用"
            prop="freightAmount"
            key="freightAmount"
          >
            <el-input
              type="number"
              v-model="editModel.freightAmount"
              placeholder="请输入配送费用"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="起送金额"
            prop="minimumAmount"
            key="minimumAmount"
          >
            <el-input
              type="number"
              v-model="editModel.minimumAmount"
              placeholder="请输入起送金额"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="加价幅度"
            prop="priceIncreaseRate"
            key="priceIncreaseRate"
          >
            <el-input
              type="number"
              v-model="editModel.priceIncreaseRate"
              placeholder="请输入加价幅度"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="分佣比例"
            prop="commissionRate"
            key="commissionRate"
          >
            <el-input
              type="number"
              v-model="editModel.commissionRate"
              placeholder="请输入分佣比例"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录账号" prop="loginUsername">
            <el-input
              placeholder="请输入登录账号"
              v-model="editModel.loginUsername"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-input
              type="password"
              :placeholder="
                editModel.guid ? '不修改密码时请留空' : '请输入登录密码'
              "
              v-model="editModel.password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="分销商电话" prop="distributorPhone">
            <el-input
              type="textarea"
              v-model="editModel.distributorPhone"
              placeholder="请输入分销商电话"
              maxlength="128"
              :rows="1"
            ></el-input>
          </el-form-item>
          <el-form-item label="分销商地址" prop="distributorAddress">
            <el-input
              type="textarea"
              v-model="editModel.distributorAddress"
              placeholder="请输入分销商地址"
              maxlength="256"
              :rows="2"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="4"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </div>
      </el-card>
    </el-form>
  </div>
  <el-card v-else-if="!loading" shadow="hover">
    <el-empty :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="fetchModel" size="small">
        重新加载
      </el-button>
    </el-empty>
  </el-card>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}
</style>

<script>
const defaultModel = {
  distributorName: "",
  distributorAddress: "",
  distributorPhone: "",
  loginUsername: "",
  freightAmount: "",
  minimumAmount: "",
  priceIncreaseRate: "",
  commissionRate: "",
  password: "",
  optRemark: "",
  optStatus: 1
}

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        distributorName: [
          {
            required: true,
            message: "请输入分销商名称",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = this.editModel.guid
            ? "biz.customer.store.distributor.update"
            : "biz.customer.store.distributor.create";
          this.requestApi(method, this.editModel, {
            showError: true
          }).then((resp) => {
            this.success("保存成功");
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.storeGuid) {
        this.editModel.storeGuid = this.pageParams.storeGuid;
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.customer.store.distributor.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid
        }).then((resp) => {
          this.editModel = resp.data;
          this.handleModel();
        }).catch((err) => {
          this.errorMsg = (err && err.msg) || (err && err.message) || "连接货位器失败，请检查网络";
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>